import {
  ADD_WIDGET,
  ADD_PACKAGE,
  CLEAR_PRODUCT,
  UPDATE_WIDGET,
} from "./types";

export function addWidget(widget: any) {
  return {
    type: ADD_WIDGET,
    data: widget
  };
}

// package is reserved keyword, so going with 'pkg'
export function addPackage(pkg: any) {
  return {
    type: ADD_PACKAGE,
    data: pkg
  };
}

export function updateWidget(id: any) {
  return {
    type: UPDATE_WIDGET,
    data: id,
  };
}

export function clearProduct(formId: string) {
  return {
    type: CLEAR_PRODUCT,
    data: formId
  };
}
